$.fn.heroVideo = function() {
    $(this).each(function() {
        var $hero = $(this);
        var heroSrc = $hero.find('source');
        var heroVideo = $hero.find('.hero__video');
        var heroPlayPauseBtn = $hero.find('.hero__play-pause');
        var heroID = heroVideo.attr('id');

        if (heroSrc.length) {
            
            // Initial check if should auto play
            if (localStorage.getItem('shouldHeroAutoPlay' + heroID)  === null) {
                heroVideo.prop('autoplay', true);
                heroVideo.get(0).play();
                heroPlayPauseBtn.attr('aria-label', 'Pause');
            }

            // Check if we should auto play video
            if (localStorage.getItem('shouldHeroAutoPlay' + heroID) === 'noAutoPlay') {
                heroVideo.removeAttr('autoplay');
                heroVideo.get(0).pause();
                heroPlayPauseBtn.attr('aria-label', 'Play');
            } else {
                heroVideo.prop('autoplay', true);
                heroVideo.get(0).play();
                heroPlayPauseBtn.attr('aria-label', 'Pause');
            }

            // Hero play/pause button
            heroPlayPauseBtn.on('click', function() {
                var $playPause = $(this);
                var associatedVideo = heroVideo.get(0);

                if (associatedVideo.paused) {
                    associatedVideo.play();
                    $playPause.attr('aria-label', 'Pause');
                    localStorage.setItem('shouldHeroAutoPlay' + heroID, 'doAutoPlay');
                } else {
                    associatedVideo.pause();
                    $playPause.attr('aria-label', 'Play');
                    localStorage.setItem('shouldHeroAutoPlay' + heroID, 'noAutoPlay');
                }
            });
        }
    });
};